import React from "react";
import { ResponsiveImage, WithLazy } from "@quintype/components";

import "./photo-story-image.m.css";

const CustomPhotoStoryImageElement = ({ element, story, allImagesInCards }) => {
  return (
    <div className="story-element story-element-photo-story-image" styleName="image-container" key={element?.id}>
      <WithLazy margin="50px">
        {() => (
          <ResponsiveImage
            slug={element?.["image-s3-key"]}
            metadata={element?.["image-metadata"]}
            aspectRatio={[4, 3]}
            defaultWidth={640}
            widths={[360, 640, 1200]}
            imgParams={{ auto: ["format", "compress"] }}
            alt={element?.title || story?.headline}
            styleName="image"
          />
        )}
      </WithLazy>
      <div styleName="image-desc">
        {Object.keys(allImagesInCards)?.length > 0 && (
          <div styleName="card-count">{`${allImagesInCards?.[element?.id]}/${
            Object.keys(allImagesInCards)?.length
          }`}</div>
        )}
        {(element?.title || element?.["image-attribution"]) && (
          <div styleName="image-content">
            {element?.title && <div styleName="image-title" dangerouslySetInnerHTML={{ __html: element?.title }} />}
            {element?.["image-attribution"] && (
              <div styleName="image-credit" dangerouslySetInnerHTML={{ __html: element?.["image-attribution"] }} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPhotoStoryImageElement;
